<template>




    <tq-tabs :p_tabs_ao="co_getRiddlesTitles_ao"
             p_att_s="title"
             :p_selected-tab-index_vn="selectedTabIndex"
             :p_display_lang-code_e="p_display_langCode_e"
             :p_system_lang-code_e="p_system_langCode_e"

             p_tabs-class_s="TQ_padding_8px"
             :p_vertical-layout_b="true"
             class="TQ_minHeight_400px TQ_bg_white TQ_padding_4px_0"

             :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteMission"
             :pe_delete-tab_click_f="(riddleIndex) => {deleteCard(riddleIndex)}"

             :p_add-tab-text_s="ass_strings.twoWords_newMission[p_display_langCode_e]"
             :pe_add-tab_click_f="newCard"

             :pe_on-change-order_f="onChangeRiddleOrder">


        <tq-riddle-data_-edit
                :style="{'padding' : helper_getDirectionByLangCode_fe(p_system_langCode_e) === enum_directions.rtl ? '0 4px 0 0' : '0 0 0 4px'}"

                v-if="riddles[selectedTabIndex.val]"
                :key="selectedTabIndex.val"
                :uid="p_uid_s + '_' + riddles[selectedTabIndex.val].qbr_riddleId_n"

                :p_qb_riddle_c="riddles[selectedTabIndex.val]"
                :lang-arr="langArr"
                :p_metadata-q-b_c="p_metadataQB_c"
                :p_system_lang-code_e="p_system_langCode_e"
                :p_qb_display-lang-code_e="p_display_langCode_e"

                :p_creator-active-payment-plan_b="p_creatorActivePaymentPlan_b"
                :p_cards-missions_b="p_cardsMissions_b"

                :pe_choose-file_f="pe_chooseFile_f"

        />

    </tq-tabs>

</template>

<script>

    import TqCard from '../../../../components/basic/TqCard'
    import TqTabs from '../../../../components/basic/TqTabs'
    import TqRiddleData_Edit from '../../../../components/complex/TqRiddleData_Edit'
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {obj_deepCopy_f} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {search_getArrObjFreeIndex} from "../../../../../functions/src/shareCode/Share_S_Search";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_directions, enum_fbPath} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {helper_getDirectionByLangCode_fe} from "../../../../scripts/S_Helper";
    import {
        FB_QuestBody_Metadata,
        FB_QuestBody_Riddle,
        FB_UserData
    } from "../../../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "C_Creator_EditQuests_Item_BodyCardsRiddles",
        components:{
            TqCard,
            TqTabs,
            TqRiddleData_Edit
        },
        props:{
            riddles:{
                type: Array,
                require: true
            },
            langArr:{
                require: true,
                type: Array
            },
            p_uid_s:{
                require: true,
                type: String,
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_display_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_metadataQB_c:{
                type: FB_QuestBody_Metadata,
                require: true,
            },
            p_cardsMissions_b : {
                type: Boolean,
                default : false
            },
            p_creatorActivePaymentPlan_b:{
                type: Boolean,
                require: true
            },

            pe_chooseFile_f: {},


        },
        data(){
            return{
                selectedTabIndex    : {val: 0},
                ass_strings         : ass_strings,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
                enum_directions : enum_directions
            }
        },
        methods:{
            newCard(){

                let title_blc_s = {}
                this.langArr.forEach(langCode => {
                    title_blc_s[langCode] = "New Card " + (this.riddles.length+1)
                })

                let riddle = new FB_QuestBody_Riddle({
                    qbr_title_blc_s : title_blc_s,
                    qbr_metadata_c  : null,
                    qbr_riddleId_n  : search_getArrObjFreeIndex(this.riddles, enum_fbPath.qbr_riddleId_n)
                }, this.langArr)

                this.riddles.push(riddle)

                this.selectedTabIndex.val = this.riddles.length - 1
            },
            deleteCard(riddleIndex){

                this.riddles.splice(riddleIndex,1)

                this.selectedTabIndex.val --

                if(this.selectedTabIndex.val < 0 )
                    this.selectedTabIndex.val = 0

            },
            copyCard(){

                if(!this.riddles[this.selectedTabIndex.val]){
                    return
                }

                let newRiddle = new FB_QuestBody_Riddle(obj_deepCopy_f(this.riddles[this.selectedTabIndex.val]))

                this.riddles.push(newRiddle)
            },
            onChangeRiddleOrder(tabs){

                let ans = []

                tabs.forEach(item => {
                    ans.push(this.riddles[item.index])
                })

                ans.forEach( (item,index)=>{
                    this.$set(this.riddles,index,item)
                })
            }
        },
        computed: {
            co_getRiddlesTitles_ao(){
                return this.riddles.map((qb_riddle_c, index_n) => {
                    return {title : qb_riddle_c.qbr_title_blc_s, index: index_n }
                })
            },
        },
    }
</script>

<style scoped lang="scss">

    .btn{
        display: inline-block;
        padding: 8px;
        margin: 4px;
        font-size: 24px;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
        color: white;
        cursor: pointer;

        &.warning{
            background : var(--color-red2)
        }
        &.danger{
            background : var(--color-gold)
        }
        &.success{
            background : var(--color-green)
        }
    }


</style>
